import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useToggleStatus = () => {
  const { mutate: toggleStatus, isPending } = useAppMutation([QueryKey.DELETE_STAKEHOLDER], {
    mutationFn: ({ companyId, stakeholderId }: { companyId: string; stakeholderId: string }) =>
      ApiService.post({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'stakeholders', stakeholderId, 'toggle-status'],
      }),
  });

  return { toggleStatus, isPending };
};
